(() => {
  const hydrateWallets = (drawer) => {
    if (!drawer) return;

    const target = drawer.querySelector('[data-cm-wallet-target]');
    const template = target && target.querySelector('template[data-cm-wallet-template]');
    if (!target || !template || target.dataset.cmWalletHydrated === 'true') return;

    target.dataset.cmWalletHydrated = 'true';
    target.appendChild(template.content.cloneNode(true));
    template.remove();

    window.requestAnimationFrame(() => {
      window.Shopify?.PaymentButton?.init?.();
    });
  };

  document.addEventListener('theme:cart-drawer:open', (event) => {
    hydrateWallets(event.detail?.target || document.querySelector('cart-drawer'));
  });
})();
